@for (_ of fakeArray; track $index) {
  <td
    style="width: 30px"
    scope="col"
    [class]="$index < whiteColumnsAtStart ? 'border-bottom-0 bg-white' : 'border-bottom-0'"
  ></td>
}
@if (showCollapseButton) {
  <td scope="col" class="border-bottom-0 pe-0" style="width: 30px">
    <a (click)="collapseEvent.emit()">
      <i
        class="fa-solid {{
          isCollapsed ? 'fa-circle-chevron-right' : 'fa-circle-chevron-down'
        }} text-secondary ms-1"
        title="'{{ itemName }}' toeklappen"
      ></i>
    </a>
  </td>
}
@if (enableSelect) {
  <td scope="col" class="border-bottom-0 px-0" style="width: 20px; vertical-align: middle">
    <div class="form-check" style="padding-left: 2.25em !important">
      <!--{{ /*config.selectStyle ? config.selectStyle(row) : */'' }}
       [disabled]="config.isDisabled && config.isDisabled(row)"
       -->
      <input
        (click)="toggleSelectItem()"
        class="form-check-input"
        type="checkbox"
        [checked]="isItemSelected()"
        [indeterminate]="isIndeterminate()"
        [disabled]="disableSelectButton"
      />
    </div>
  </td>
}

@for (column of columns; track column.label) {
  @if (
    item.hasChildren(item.instance)
      ? column.colSpanA == undefined || column.colSpanA > 0
      : column.colSpanB == undefined || column.colSpanB > 0
  ) {
    <td
      [style.width]="column.width"
      [style.maxWidth]="column.maxWidth"
      class="border-bottom-0 ps-0"
      [colSpan]="
        ($index === 1 ? 1 : firstColumnColspan) +
        (item.hasChildren(item.instance) ? (column.colSpanA ?? 1) : (column.colSpanB ?? 1)) -
        1
      "
    >
      <div
        [classList]="
          'ps-1 ' +
          (column.classes ? column.classes(item.instance) : '') +
          (column.cellClick ? ' cursor-pointer' : '')
        "
        (click)="onCellClick(column, item.instance)"
      >
        @if (item.hasChildren(item.instance)) {
          @if (column.templateA || column.template) {
            <ng-container
              *ngTemplateOutlet="column.templateA ?? column.template!; context: { $implicit: item }"
            ></ng-container>
          } @else if (column.componentA || column.component) {
            <ng-container
              *ngComponentOutlet="
                (column.componentA ?? column.component)!.component();
                inputs: column.componentA && column.componentA.componentInputs
                  ? column.componentA.componentInputs(item.instance)
                  : column.component && column.component.componentInputs
                    ? column.component.componentInputs(item.instance)
                    : {};
                ndcDynamicOutputs: column.componentA && column.componentA.componentOutputs
                  ? column.componentA.componentOutputs(item.instance)
                  : column.component && column.component.componentOutputs
                    ? column.component.componentOutputs(item.instance)
                    : {}
              "
            ></ng-container>
          } @else {
            @if (column.routerLink) {
              <a
                [innerHTML]="
                  column.formatA
                    ? column.formatA(item.instance)
                    : column.format
                      ? column.format(item.instance)
                      : ''
                "
                [routerLink]="getRouterLink(column, item.instance)"
                [queryParams]="getQueryParams(column, item.instance)"
              ></a>
            } @else {
              <div
                [innerHTML]="
                  column.formatA
                    ? column.formatA(item.instance)
                    : column.format
                      ? column.format(item.instance)
                      : ''
                "
              ></div>
            }
          }
        } @else {
          <!--TODO: duplicate code as above, move to template or component-->
          @if (column.templateB || column.template) {
            <ng-container
              *ngTemplateOutlet="column.templateB ?? column.template!; context: { $implicit: item }"
            ></ng-container>
          } @else if (column.componentB || column.component) {
            <ng-container
              *ngComponentOutlet="
                (column.componentB ?? column.component)!.component();
                inputs: column.componentB && column.componentB.componentInputs
                  ? column.componentB.componentInputs(item.instance)
                  : column.component && column.component.componentInputs
                    ? column.component.componentInputs(item.instance)
                    : {};
                ndcDynamicOutputs: column.componentB && column.componentB.componentOutputs
                  ? column.componentB.componentOutputs(item.instance)
                  : column.component && column.component.componentOutputs
                    ? column.component.componentOutputs(item.instance)
                    : {}
              "
            ></ng-container>
          } @else {
            @if (column.routerLink) {
              <a
                [innerHTML]="
                  column.formatB
                    ? column.formatB(item.instance)
                    : column.format
                      ? column.format(item.instance)
                      : ''
                "
                [routerLink]="getRouterLink(column, item.instance)"
                [queryParams]="getQueryParams(column, item.instance)"
              ></a>
            } @else {
              <div
                [innerHTML]="
                  column.formatB
                    ? column.formatB(item.instance)
                    : column.format
                      ? column.format(item.instance)
                      : ''
                "
              ></div>
            }
          }
        }
      </div>
    </td>
  }
}
@if (actions.length > 0 || defaultActions.length > 0) {
  <td
    scope="col"
    class="text-end d-flex justify-content-end border-bottom-0"
    style="padding-right: 0.75rem"
  >
    <app-action-group [actions]="actions" [row]="item.instance"></app-action-group>
    <app-default-actions-group
      [actions]="defaultActions"
      [item]="item.instance"
      [itemLabel]="itemLabel"
      [itemName]="itemName"
      (addEvent)="addEvent.emit($event)"
      (moveEvent)="moveEvent.emit($event)"
      (deleteEvent)="deleteEvent.emit($event)"
      [isFirst]="isFirst"
      [isLast]="isLast"
    ></app-default-actions-group>
  </td>
}
